import { useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useImmer } from 'use-immer'
import { Button, FormControl, FormLabel, Input, VStack } from '@chakra-ui/react'

export const ExistingSignOptionFormType = {
  Add: 'add',
  Edit: 'edit'
}

export const ExistingSignOptionForm = ({ type, onSubmit, isSubmitting, initialForm = null }) => {
  const [form, setForm] = useImmer({
    description: '',
    cost: 0
  })

  const buttonText = useMemo(() => {
    switch (type) {
      case ExistingSignOptionFormType.Add:
        return 'Add Option'
      case ExistingSignOptionFormType.Edit:
        return 'Save Option'
    }
  }, [type])

  useEffect(() => {
    setForm(draft => {
      Object.keys(initialForm || {}).forEach(k => { draft[k] = initialForm[k] ?? '' })
    })
  }, [initialForm])

  const handleChange = (e) => {
    setForm(draft => {
      draft[e.target.name] = e.target.value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(form)
  }

  return (
    <form onSubmit={handleSubmit}>
      <VStack gap={2} maxW="500px">
        <FormControl isRequired>
          <FormLabel>Description</FormLabel>
          <Input name="description" value={form.description} onChange={handleChange} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Cost</FormLabel>
          <Input type="number" name="cost" value={form.cost} onChange={handleChange} />
        </FormControl>
      </VStack>
      <Button type="submit" mt={8} colorScheme="blue" isLoading={isSubmitting}>{buttonText}</Button>
    </form>
  )
}

ExistingSignOptionForm.propTypes = {
  type: PropTypes.oneOf(Object.values(ExistingSignOptionFormType)).isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  initialForm: PropTypes.object
}
